module.exports = __webpack_public_path__ + "media/pl_pl_s4_Wojciech.2a89065d.mp3";